/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import {
  Redirect, useHistory, useLocation, useParams
} from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { _ } from '_locales';
import HOC from '../HOC';

import QuizOption from './components/QuizOption';
// import { setIsQuizDone } from '../../helpers/gamification';
// import { trackEvent } from '../../helpers/common';
// import { acquireBadge } from '../../app/apis';
// import CustomButton from '../../common/CustomButton';
import { BodyText, Container, LinkButton } from './styles';
import events from '../Education/events';
import { Button } from '../Education/components';

const quizType = {
  rf: {
    quiz: 'rfQuiz',
    data: 'recyclingFundamentals',
    landEvent: events.DZ_RF_QUIZ_LAND,
    optionSelectEvent: events.DZ_RF_QUIZ_SELECT_OPTION,
    backButtonEvent: events.DZ_RF_QUIZ_BACK_TAP,
  },
  lm: {
    quiz: 'lmQuiz',
    data: 'learningModules',
    landEvent: 'DZ_LM_QUIZ_LAND',
    optionSelectEvent: 'DZ_LM_QUIZ_SELECT_OPTION',
    backButtonEvent: 'DZ_LM_QUIZ_BACK_TAP',
  },
  mum: {
    quiz: 'mumQuiz',
    data: 'misundestoodMaterials',
    landEvent: events.DZ_MM_QUIZ_LAND,
    optionSelectEvent: events.DZ_MM_QUIZ_SELECT_OPTION,
    backButtonEvent: events.DZ_MM_QUIZ_BACK_TAP,
  },
};

const Body = styled.p`
  margin-bottom: 10px;
`;

const Title = styled.h3`
  margin-bottom: 10px;
`;

const NextButton = styled.button`
  margin-bottom: 5px;
  margin-top: 5px;
`;

const OptionsContainer = styled.div`
  margin-bottom: 20px;
`;

const Quiz = ({
  setQuizState,
  updateQuizData,
  quizData,
  syncState,
  tookRfQuiz,
  tookMmQuiz,
  tookLmQuiz,
  setTimesTookRfQuiz,
  setTimesTookLmQuiz,
  setTimesTookMmQuiz,
  setHeaderState,
  quizState,
  learningModulesRedux,
  uuid,
  projectId
}) => {
  const { state } = useLocation();
  const { type, quizIndex } = useParams();
  const [didAnswer, setDidAnswer] = useState(false);
  const { replace, goBack } = useHistory();
  const quizes = state?.isLearningModule
    ? quizData[quizType[type].quiz][state.lmIndex]
    : quizData[quizType[type].quiz];

  useEffect(() => {
    const {
      id, oidx, campaign_id = null, activityId = null
    } = nav.current;
    const eventData = {};
    if (quizType[type].quiz === 'rfQuiz') {
      eventData.coachable_id = id;
      eventData.campaign_id = activityId;
    }
    if (quizType[type].quiz === 'lmQuiz') {
      eventData.coachable_id = id;
      eventData.lm_id = campaign_id;
      eventData.campaign_id = campaign_id;
    }
    if (quizType[type].quiz === 'mumQuiz') eventData.mat_id = id;
    // trackEvent(quizType[type].landEvent, eventData);
    setHeaderState({ id, lesson_oidx: oidx });
  }, [type, quizIndex]);

  const nav = {
    current: quizes[Number(quizIndex)],
    next: quizes[Number(quizIndex) + 1],
    prev: quizes[Number(quizIndex) - 1],
  };
  const { title, options, question } = nav.current;

  const [quizOptions, setQuizOptions] = useState(options);
  useEffect(() => {
    const { options: theOptions } = nav.current;
    setQuizOptions(options);
    setDidAnswer(!!theOptions.find(({ selected }) => selected));
  }, [nav.current]);

  const getBadgeOf = async (badgeName) => {
    try {
      // await axios.post(acquireBadge(), {
      //   project_id: projectId,
      //   device_id: uuid,
      //   badge_name: badgeName,
      // });
    } catch (e) {
      throw new Error(e);
    }
  };

  const canGetLMBadge = (quizzes, answers) => {
    const totalQuizCount = quizzes.length;
    const answeredQuizCount = quizzes.filter(({ answered }) => answered).length;
    const correctAnswerCount = Object.values(answers).filter(
      ({ passed }) => passed
    ).length;
    const { badge } = learningModulesRedux[state.lmIndex].badge;
    const { condition } = learningModulesRedux[state.lmIndex].badge;

    let result = false;
    switch (condition) {
      case 'QUIZ_80':
        if (correctAnswerCount / totalQuizCount >= 0.8) {
          getBadgeOf(badge);
          result = true;
        }
        break;
      case 'QUIZ_100':
        if (correctAnswerCount / totalQuizCount === 1) {
          getBadgeOf(badge);
          result = true;
        }
        break;
      case 'VIEW_80':
        if ((answeredQuizCount + 1) / totalQuizCount >= 0.8) {
          getBadgeOf(badge);
          result = true;
        }
        break;
      case 'VIEW_100':
        if (answeredQuizCount / totalQuizCount === 1) {
          getBadgeOf(badge);
          result = true;
        }
        break;
      default:
    }

    return result;
  };

  const proceed = () => {
    const {
      id,
      options: theOptions,
      correctOption,
      oidx: mat_oidx,
      activityId = null,
      campaign_id = null,
      ...rest
    } = nav.current;

    const { value: selectedOptionId } = theOptions.find(
      ({ selected }) => selected
    );
    const didAnswerCorrect = selectedOptionId === correctOption;
    const updatedQuizes = [...quizes].map((item) => {
      const newItem = item;
      if (newItem.id === id) {
        newItem.answered = true;
      }
      return newItem;
    });
    const eventData = {
      correct: didAnswerCorrect,
      selected_id: selectedOptionId,
      ...(quizType[type].quiz === 'rfQuiz'
        ? { coachable_id: id, campaign_id: activityId }
        : {}),
      ...(quizType[type].quiz === 'lmQuiz'
        ? { coachable_id: id, campaign_id }
        : {}),
      ...(quizType[type].quiz === 'mumQuiz' ? { mat_id: id, mat_oidx } : {}),
    };
    // trackEvent(quizType[type].optionSelectEvent, eventData);
    if (state?.isLearningModule) {
      const updatedQuizData = quizData[quizType[type].quiz].map((item, idx) => {
        if (idx === state?.lmIndex) {
          return updatedQuizes;
        }
        return item;
      });
      updateQuizData({ [quizType[type].quiz]: updatedQuizData });

      const updatedQuizState = quizData[quizType[type].quiz].map((_, idx) => {
        if (idx === state?.lmIndex) {
          return {
            ...quizData.quizState[quizType[type].quiz][state?.lmIndex],
            [id]: {
              passed: didAnswerCorrect,
              failed: !didAnswerCorrect,
              options: theOptions,
              correctOption,
              ...rest,
            },
          };
        }
        return {};
      });

      // const [_, ___] = setIsQuizDone(
      //   quizType[type].quiz,
      //   canGetLMBadge(
      //     updatedQuizData[state?.lmIndex],
      //     updatedQuizState[state?.lmIndex]
      //   )
      // );

      setQuizState({ ...quizState, lmQuiz: updatedQuizState });
    } else {
      updateQuizData({ [quizType[type].quiz]: updatedQuizes });
      setQuizState({
        ...quizState,
        [quizType[type].quiz]: {
          ...quizData.quizState[quizType[type].quiz],
          [id]: {
            passed: didAnswerCorrect,
            failed: !didAnswerCorrect,
            options: theOptions,
            correctOption,
            ...rest,
          },
        },
      });
    }

    syncState();
    if (nav.next) {
      return replace(`/quiz/${type}/${nav.next.oidx}`, {
        lmIndex: state?.lmIndex,
        isLearningModule: state?.isLearningModule,
      });
    }
    if (quizType[type].quiz === 'rfQuiz') setTimesTookRfQuiz({ ...tookRfQuiz, count: (tookRfQuiz.count || 0) + 1 });
    if (quizType[type].quiz === 'lmQuiz') setTimesTookLmQuiz({ ...tookLmQuiz, count: (tookLmQuiz.count || 0) + 1 });
    if (quizType[type].quiz === 'mumQuiz') setTimesTookMmQuiz({ ...tookMmQuiz, count: (tookMmQuiz.count || 0) + 1 });

    // if (quizType[type].quiz !== 'lmQuiz') {
    //   const [badgeName, isDone] = setIsQuizDone(quizType[type].quiz);
    //   if (isDone) getBadgeOf(badgeName);
    // }

    syncState();
    return replace(`/quiz-feedback/${type}`, {
      lmIndex: state?.lmIndex,
      isLearningModule: state?.isLearningModule,
    });
  };

  const handleQuizSelection = (opt) => {
    const newQuizOptions = [...quizOptions];
    const { correctOption } = nav.current;
    // eslint-disable-next-line no-restricted-syntax
    for (const qOption of newQuizOptions) {
      qOption.selected = false;
      qOption.nuetral = qOption.value !== correctOption;
      if (qOption.value === opt) {
        qOption.selected = true;
        qOption.nuetral = false;
      }
    }
    setQuizOptions(newQuizOptions);
    setDidAnswer(true);
  };

  const backHandler = () => {
    // trackEvent(quizType[type].backButtonEvent);
    goBack();
  };

  if (!nav) return null;

  if (!quizes.length) {
    return <Redirect to="/" />;
  }

  return (
    <div style={{ marginTop: 100 }}>
      <Container>
        {type === 'mum' ? (
          <>
            <Body>{title}</Body>
            <Title>{question}</Title>
          </>
        ) : null}
        {type === 'lm' ? (
          <>
            <Title>{title}</Title>
            <BodyText>
              <Body dangerouslySetInnerHTML={{ __html: question }} />
            </BodyText>
          </>
        ) : null}
        {type === 'rf' ? (
          <>
            <Title>{title}</Title>
            <BodyText>
              <Body dangerouslySetInnerHTML={{ __html: question }} />
            </BodyText>
          </>
        ) : null}
        <OptionsContainer>
          {quizOptions.map(
            ({
              id: optionsID, label, value, selected, nuetral
            }) => label && (
              <QuizOption
                key={`q-opt-${optionsID}`}
                value={value}
                selected={selected}
                nuetral={nuetral}
                isResult={false}
                onClick={handleQuizSelection}
              >
                {label}
              </QuizOption>
            )
          )}
        </OptionsContainer>

        <Button
          style={{ margin: '5px 0' }}
          disabled={!didAnswer}
          className="btn outline royal"
          onClick={proceed}
        >
          {/* {__('app.next')} */}
          Nextaa
        </Button>
        <LinkButton onClick={backHandler}>
          {
            'app back aa'
            // __('app.back')
          }
        </LinkButton>
      </Container>
    </div>
  );
};

export default HOC(Quiz);
